import { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { HOST_URL, reqOptions } from "../../assets/js/helpFunction";
import styled from "styled-components";
import WithAuth from "../../components/partials/withAuth";
import { SVGs } from "../../assets/svg/SVGs";
import { getEstateID, MssgContainer } from "../../components/partials/utils";
import { useCurrentLocation } from "../../utils/useLocation";

const CheckpointsComp = () => {
  const [openModal, setOpenModal] = useState(false);
  const [edit, setEdit] = useState(false);
  const [checkpoints, setCheckpoints] = useState([]);
  const [data, setData] = useState({});
  const [editedCheckpoint, setEditedCheckpoint] = useState({});
  const [mssg, setMssg] = useState({ error: false, mssg: "" });
  const [loading, setLoading] = useState(false);
  const [deleting, setDeleting] = useState(false);

  const closeMssg = () => {
    setMssg({ error: false, mssg: "" });
  };

  const fetchCheckpoints = () => {
    const requestOptions = reqOptions("get", null, true);
    const api = `${HOST_URL()}patrols/manage/checkpoints?estate_id=${getEstateID()}`;
    fetch(api, requestOptions)
      .then((res) => res.json())
      .then((data) => {
        setCheckpoints(data.results);
        setData(data);
      })
      .catch((err) => setMssg({ ...mssg, mssg: err.message, error: true }));
  };

  useEffect(() => {
    fetchCheckpoints();
  }, []);

  const editCheckpoint = (id) => {
    const item = checkpoints.find((element) => element.id == id);
    setEditedCheckpoint(item);
    setEdit(true);
    setOpenModal(true);
  };

  const addUtility = (checkpoint) => {
    setLoading(true);
    if (edit) {
      const api = `${HOST_URL()}patrols/manage/checkpoints/${editedCheckpoint?.id}/?estate_id=${getEstateID()}`;
      const requestOptions = reqOptions(
        "patch",
        JSON.stringify(checkpoint),
        true,
      );
      fetch(api, requestOptions)
        .then((res) => res.json())
        .then((data) => {
          if (data.id) {
            setMssg({ ...mssg, mssg: "Checkpoint Updated successfully" });
            fetchCheckpoints();
            // const edited_data = checkpoints.map((item) => {
            //   if (item.id == editedCheckpoint.id) {
            //     return data;
            //   }
            //   return item;
            // });
            // setCheckpoints(edited_data);
            setOpenModal(false);
          } else {
            setMssg({
              ...mssg,
              mssg: "Error Updating Checkpoint",
              error: true,
            });
          }
        })
        .catch((err) => setMssg({ ...mssg, mssg: err.message, error: true }))
        .finally(() => {
          setLoading(false);
        });
    } else {
      const api = `${HOST_URL()}patrols/manage/checkpoints/?estate_id=${getEstateID()}`;
      const requestOptions = reqOptions(
        "post",
        JSON.stringify(checkpoint),
        true,
      );
      fetch(api, requestOptions)
        .then((res) => res.json())
        .then((data) => {
          if (data.id) {
            setMssg({ ...mssg, mssg: "Checkpoint Created successfully" });
            // setCheckpoints([...checkpoints, data]);
            fetchCheckpoints();
            setOpenModal(false);
          } else {
            setMssg({
              ...mssg,
              mssg: "Error Creating Checkpoint",
              error: true,
            });
          }
        })
        .catch((err) => {
          setMssg({ ...mssg, mssg: err.name, error: true });
        })
        .finally(() => {
          setLoading(false);
        });
    }
  };

  const deleteCheckpoint = (id) => {
    setDeleting(true);
    const api = `${HOST_URL()}patrols/manage/checkpoints/${id}/?estate_id=${getEstateID()}`;
    const requestOptions = reqOptions("delete", null, true);
    fetch(api, requestOptions)
      .then((res) => {
        if (res?.ok) {
          fetchCheckpoints();
          setMssg({
            ...mssg,
            mssg: "Checkpoint deleted successfully",
            error: true,
          });
        }
      })
      .catch((err) => {
        setMssg({ ...mssg, mssg: err.message, error: true });
      })
      .finally(() => setDeleting(false));
  };

  const handleCloseModal = () => {
    setOpenModal(false);
    setEditedCheckpoint({});
    setEdit(false);
  };

  return (
    <div style={{ minHeight: "50vh" }}>
      {mssg.mssg && <MssgContainer mssg={mssg} close={closeMssg} />}
      <h1 style={{ textAlign: "center" }}>Checkpoints</h1>
      <div>
        <button className="important-btn" onClick={() => setOpenModal(true)}>
          Create Chekckpoint
        </button>
      </div>
      <CheckpointGrid>
        <div className="Utility_table">
          {checkpoints.length ? (
            checkpoints?.map((checkpoint, index) => (
              <Checkpoint
                key={index}
                deleteCheckpoint={deleteCheckpoint}
                deleting={deleting}
                fetchCheckpoints={fetchCheckpoints}
                checkpoints={checkpoints}
                checkpoint={checkpoint}
                editCheckpoint={editCheckpoint}
              />
            ))
          ) : (
            <p>
              No checkpoint created at the moment.{" "}
              <a
                onClick={() => setOpenModal(true)}
                style={{
                  cursor: "pointer",
                  color: "#2D4BF3",
                  fontWeight: "bolder",
                }}
              >
                Create one
              </a>
            </p>
          )}
        </div>
      </CheckpointGrid>
      <Modal
        mssg={mssg}
        loading={loading}
        checkpoints={checkpoints}
        open={openModal}
        onClose={handleCloseModal}
        addUtility={addUtility}
        edit_data={editedCheckpoint}
        edit={edit}
      />
    </div>
  );
};

export default CheckpointsComp;

const Checkpoint = ({
  checkpoints,
  checkpoint,
  editCheckpoint,
  fetchCheckpoints,
  deleteCheckpoint,
  deleting,
}) => {
  const [openModal, setOpenModal] = useState(false);
  const [report, setReports] = useState([]);
  const [data, setData] = useState({});
  const [patrolArea, setPatrolArea] = useState({});

  const fetchPatrolArea = (checkpointPatrolArea) => {
    const requestOptions = reqOptions("get", null, true);
    const api = `${HOST_URL()}patrols/manage/areas/${checkpointPatrolArea}/?estate_id=${getEstateID()}`;
    fetch(api, requestOptions)
      .then((res) => res.json())
      .then((data) => {
        setPatrolArea(data);
      })
      .catch((err) => {
        // setMssg({ ...mssg, mssg: err.message, error: true })
      });
  };

  useEffect(() => {
    if (checkpoint?.patrol_area) fetchPatrolArea(checkpoint?.patrol_area);
  }, [checkpoint?.patrol_area]);

  const addReport = (report) => {
    setReports((prev) => [...prev, report]);
  };

  const handleCloseModal = () => {
    setOpenModal(false);
  };

  return (
    <>
      <div className="utils">
        <div className="util-payment">
          <div className="name_tag">
            <h4>{checkpoint.name}</h4>
            {/* <button>{checkpoint.name}</button> */}
          </div>

          <div className="util-acct">
            <p>
              Name: <b>{checkpoint.name || "-"}</b>
            </p>
            <p>
              Patrol Area: <b>{patrolArea?.name || ""}</b>
            </p>
            <p>
              Radius Meters: <b>{checkpoint.radius_meters || "-"}</b>
            </p>
            <p>
              Order: <b>{checkpoint.order || "-"}</b>
            </p>
          </div>
          <div style={{ marginTop: "15px" }}>
            <span
              className="edit-btn util-btn"
              onClick={() => editCheckpoint(checkpoint.id)}
            >
              Edit
            </span>
            <span
              aria-disabled={deleting}
              className="del-btn util-btn"
              onClick={() => deleteCheckpoint(checkpoint.id)}
            >
              {/* {deleting ? "Deleting..." : "Delete"} */}
              Delete
            </span>
          </div>
        </div>
      </div>
    </>
  );
};

const Modal = ({
  mssg,
  loading,
  open,
  onClose: passedClose,
  addUtility,
  edit_data,
  edit,
  checkpoints,
}) => {
  const default_checkpoint = {
    patrol_area: edit_data?.patrol_area || "",
    name: edit_data?.name || "",
    center_lat: edit_data?.center_lat || "",
    center_lng: edit_data?.center_lng || "",
    radius_meters: edit_data?.radius_meters || "",
    order: edit_data?.order || 0,
  };
  const [checkpoint, setCheckpoint] = useState(default_checkpoint);
  const [locationChoice, setLocationChoice] = useState(null);
  const { loading: locationLoading, getLocation } = useCurrentLocation();
  const [patrolAreas, setPatrolAreas] = useState([]);

  useEffect(() => {
    if (edit_data) {
      setCheckpoint({
        patrol_area: edit_data?.patrol_area,
        name: edit_data?.name,
        center_lat: edit_data?.center_lat,
        center_lng: edit_data?.center_lng,
        radius_meters: edit_data?.radius_meters,
        order: edit_data?.order,
      });
    }
  }, [edit_data]);

  const fetchPatrolAreas = () => {
    const requestOptions = reqOptions("get", null, true);
    const api = `${HOST_URL()}patrols/manage/areas?estate_id=${getEstateID()}`;
    fetch(api, requestOptions)
      .then((res) => res.json())
      .then((data) => {
        setPatrolAreas(data.results);
      })
      .catch((err) => {
        // setMssg({ ...mssg, mssg: err.message, error: true })
      });
  };

  useEffect(() => {
    fetchPatrolAreas();
  }, [open]);

  if (!open) return null;
  const handleChange = (e) => {
    const { name, value } = e.target;
    setCheckpoint({ ...checkpoint, [name]: value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    addUtility(checkpoint);
    setCheckpoint(default_checkpoint);
    onClose(false);
  };
  const isValid =
    checkpoint?.patrol_area &&
    checkpoint?.name &&
    checkpoint?.center_lat &&
    checkpoint?.center_lng &&
    checkpoint?.radius_meters &&
    checkpoint?.order;

  const onClose = () => {
    passedClose();
    setCheckpoint(default_checkpoint);
  };

  return (
    <div onClick={onClose} className="bills_on_me">
      <div
        onClick={(e) => {
          e.stopPropagation();
        }}
        className="modalContainer"
      >
        <div className="new_estates_form fade-in-bck">
          <div className="form-group">
            <div className="create_est ">
              <div className="form_txt">
                <h3>{edit ? "Edit" : "Add a"} checkpoint</h3>
              </div>
              <input
                type="text"
                value={checkpoint.name}
                name="name"
                placeholder="Name"
                onChange={handleChange}
              />
              <p>Select a patrol area</p>
              <select
                placeholder="Patrol Area"
                value={checkpoint.patrol_area}
                name="patrol_area"
                onChange={handleChange}
                className="form-control"
                style={{ marginBottom: "16px" }}
              >
                <option value={""} key={""}>
                  Select Patrol Area
                </option>
                {patrolAreas?.map((patrolArea) => (
                  <option value={patrolArea.id} key={patrolArea.id}>
                    {patrolArea.name}
                  </option>
                ))}
              </select>
              <select
                placeholder="LocationChoice"
                value={locationChoice}
                name="location choice"
                onChange={async (e) => {
                  if (e.target.value === "cordinates") {
                    setLocationChoice(e.target.value);
                  } else {
                    const { latitude, longitude } = await getLocation();
                    if (!latitude && !longitude)
                      return alert("Error while fetching cordinates");

                    setCheckpoint((prev) => ({
                      ...prev,
                      center_lat: latitude,
                      center_lng: longitude,
                    }));
                  }
                }}
                className="form-control"
                style={{ marginBottom: "16px" }}
              >
                <option value="">How do you want to get location</option>
                <option value={"device"}>
                  Use Device (You must be at the spot)
                </option>
                <option value={"cordinates"}>Enter the cordinates</option>
              </select>
              <input
                type="number"
                placeholder="Center Latitude"
                value={checkpoint.center_lat}
                name="center_lat"
                onChange={handleChange}
              />
              <input
                type="text"
                placeholder="Center Longitude"
                value={checkpoint.center_lng}
                name="center_lng"
                onChange={handleChange}
              />
              <input
                type="number"
                placeholder="Radius Meter"
                value={checkpoint.radius_meters}
                name="radius_meters"
                onChange={handleChange}
              />
              <input
                type="number"
                placeholder="Order"
                value={checkpoint.order}
                name="order"
                onChange={handleChange}
              />
            </div>
          </div>
          {mssg?.mssg && (
            <p style={{ color: "red", fontSize: "12px", textAlign: "center" }}>
              {mssg?.mssg}
            </p>
          )}
          <button
            style={{ marginTop: 40 }}
            disabled={!isValid || loading}
            className="btn btn-success btn-block"
            onClick={handleSubmit}
          >
            {loading ? "Loading..." : `${edit ? "Edit" : "Add"} checkpoint`}
          </button>
        </div>
        <img src={SVGs.close} alt="" onClick={onClose} />
      </div>
    </div>
  );
};

const HandleSearchAndTab = styled.section`
  .container {
    margin-bottom: 20px;
  }
  .normal_tab {
    background: transparent;
  }
  .event-input {
    max-width: 675px;
  }
  @media (max-width: 420px) {
    .search_set,
    button {
      width: 100%;
      margin-bottom: 20px;
    }
  }
  @media (min-width: 760px) {
    display: flex;
    justify-content: space-between;
    .search_set {
      width: 220px;
    }
    .outlined {
      width: 180px !important;
    }
    .event-input {
      display: flex;
      justify-content: space-between;
      //   width: 57%;
      .select_me {
        margin: 0 10px;
        width: 135px;
      }
      button {
        margin-top: 0;
        height: 45px;
        margin-left: 10px;
      }
      .event-select {
        width: 20%;
      }
    }
  }
  @media (max-width: 540px) {
    .event-input {
      .event-select {
        display: none;
      }
    }
  }
  .tabs {
    margin: 0;
    margin-bottom: 30px;
    .tab {
      margin: 0;
      height: 45px;
      align-items: center;
      display: flex;
      justify-content: center;
      padding: 0;
      min-width: 100px;
      padding: 5px 20px;
      text-align: center;
      margin-right: 15px;
      border-bottom: 3px solid #c0c0c0;
      button {
        margin: 0;
        padding: 0 !important;
        padding: 10px;
        //styleName: Web/Small Copy;

        font-size: 16px;
        font-weight: 400;
        line-height: 17px;
        letter-spacing: 0em;
        text-align: left;
      }
    }
    .active {
      background: transparent;
      border-bottom: 3px solid #2d4bf3;
      button {
        color: #2d4bf3;
      }
    }
  }
  .normal_tab.add_tape {
    border-bottom: 2px solid yellow;
  }
`;
const CheckpointGrid = styled.div`
  .team-members {
    margin-top: 40px;
  }

  .Utility_table {
    display: flex;
    flex-wrap: wrap;
  }
  .btn {
    display: flex;
  }
  .utils {
    margin-bottom: 10px;
    margin: 10px;
    padding: 16px;
    width: 100%;
    border: 1px solid #2d4bf3;
    border-radius: 5px;
    .name_tag {
      h4 {
        font-size: 18px;
        font-weight: 700;
        line-height: 24px;
        letter-spacing: 0em;
        text-align: left;
      }
      button {
        margin: 0;
        font-weight: 400;
        padding: 2px 8px;

        font-size: 14px;
        margin-top: 10px;
        background: #f2f6ff;
        border: 1px solid #2d4bf3;
        border-radius: 5px;
      }
    }
  }

  .reason {
    width: 128px;
    height: 24px;
    background: #f2f6ff;
    border: 1px solid #2d4bf3;
    border-radius: 5px;
    padding: 4px 8px;
  }
  .price {
    margin-top: 10px;
  }
  .util-acct {
    margin-top: 10px;
  }

  .util-btn {
    font-weight: 500;
    font-size: 16px;
    line-height: 16px;
    cursor: pointer;
    margin-right: 10px;
  }
  .del-btn {
    color: #ff6969;
  }
  .edit-btn {
    color: #2d4bf3;
  }
  @media (min-width: 540px) {
    .utils {
      width: 48%;
    }
  }
  @media (min-width: 1024px) {
    .utils {
      width: 33%;
    }
  }
  @media (min-width: 1200px) {
    .utils {
      width: 24%;
    }
  }
`;
